import React from "react";
import styled from "styled-components";
import {ContainerBody, WrapperContato} from "../styleMobile";
import {Facebook, Instagram, Linkedin, Mail, Map, MapPin, Phone, Youtube} from "react-feather";
import {ContainerInfo, ContainerMap} from "../../Contato/styleContato";


export const CollHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 20%; 
  color: black;
  span{
    margin-top: 10px;
    font-size: 0.8rem;
    color: white;    
  }
  h2{
     color: #164a60;  
     font-size: 6vw;
     margin: 0;
   }
`;

export const CollForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 60%; 
  background: white;
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
`;

export const CollIcon = styled.div`
  display: flex;
  justify-content: space-between;
  width: 70%;
  color: #696969;
  height: 20px; 
  margin-top: 20px;

  div{
   :hover {
       opacity: 1;
       transform: scale(1.1);
    }
  }
  
`;

export const CollEndereco = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  width: 100%;
  color: black;
  height: 35%; 
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  margin-bottom: 20px;
  margin-top: 20px;
  
`;


export const WrapperEnd= styled.div`
  display: flex;
  width: 100%;
  color: black;
  height: 30px;

`;

export const WrapperIcone = styled.div`
  display: flex;
  width: 50px;
  color: black;
  height: 100%;

  justify-content: center;
  align-items: center;
`;
export const WrapperTexto = styled.div`
  display: flex;
  width: 100%;
  color: black;
  height: 100%;
  margin-right: 30px;

  justify-content: center;
  align-items: center;
  font-size: 12px;
  
  fone{
    font-weight: bold;
    font-size: 20px;
  }
`;




export const Endereco = ({id}) => {
    return (
        <ContainerBody id={id} background={'#D0D0D0'}>
            <WrapperContato>

                <CollHeader>
                    <div><Map size={'40px'}/></div>
                    <h2>CONTATO</h2>
                </CollHeader>
                <CollForm>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d906.6347787240228!2d-48.62033202625551!3d-27.585750696659744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95274977a9f73b15%3A0x2f3aa5bdbfb1312f!2sWAVECODE%20%7C%20Tecnologia%20em%20Preg%C3%B5es%20Eletr%C3%B4nicos!5e0!3m2!1spt-BR!2sbr!4v1583444674765!5m2!1spt-BR!2sbr"
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{border: 0}}
                        allowFullScreen=""
                    ></iframe>
                </CollForm>
                <CollEndereco>
                    <WrapperEnd>
                        <WrapperIcone>
                            <Phone/>
                        </WrapperIcone>
                        <WrapperTexto>
                            <fone>48 3375-2379</fone>
                        </WrapperTexto>
                    </WrapperEnd>

                    <WrapperEnd>
                        <WrapperIcone>
                            <MapPin/>
                        </WrapperIcone>
                        <WrapperTexto>
                            Rua. João Grumiche, 2217 - Sl.501 <br/>CEP: 88108-167 São José, SC.
                        </WrapperTexto>
                    </WrapperEnd>

                    <WrapperEnd>
                        <WrapperIcone>
                            <Mail/>
                        </WrapperIcone>
                        <WrapperTexto>
                            contato@wavecode.com.br
                        </WrapperTexto>
                    </WrapperEnd>

                    <CollIcon>
                        <div>
                            <Instagram
                                onClick={() =>
                                    window.open("https://instagram.com/wavecodeoficial", "_blank")
                                }
                            />
                        </div>
                        <div>
                            <Linkedin
                                onClick={() =>
                                    window.open(
                                        "https://br.linkedin.com/company/wavecode-desenvolvimento-de-softwares",
                                        "_blank"
                                    )
                                }
                            />
                        </div>
                        <div>
                            <Youtube
                                onClick={() =>
                                    window.open(
                                        "https://www.youtube.com/channel/UCOxqBMtrdt8NwJgBXxbCaig",
                                        "_blank"
                                    )
                                }
                            />
                        </div>
                        <div>
                            <Facebook
                                onClick={() =>
                                    window.open(
                                        "https://www.facebook.com/lancesautomaticos/",
                                        "_blank"
                                    )
                                }
                            />
                        </div>
                    </CollIcon>

                </CollEndereco>



            </WrapperContato>
        </ContainerBody>
    )
};
